import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getSingleRuleItemDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/risk-center/rules/${id}`);
};

export const getSingleWhitelistItemDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/risk-center/whitelists/${id}`);
};

export const getSingleBlacklistItemDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/risk-center/blacklists/${id}`);
};
